import { createStore } from 'vuex';
import auth from '@/store/modules/auth';
import website from '@/store/modules/website';

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    website,
  },
});
